import { useEntitlements, usePermission } from "@how/app-kit";
import { formatSermonDate } from "@how/website-core";
import type { SermonChoice } from "./BlockFields";
import { useSermons, useSermonSeries } from "./sermon-queries";

/**
 * The series and published sermons the sermon feature block can point at (ADR 0061), for the page editor. Empty for a
 * church without sermons and media, or an editor without sermons.manage (who can still keep a block on "newest").
 */
export function useSermonChoices():
  | { readonly series: readonly SermonChoice[]; readonly sermons: readonly SermonChoice[] }
  | undefined {
  const entitlements = useEntitlements();
  const canRead = usePermission("sermons.manage", { module: "sermons_media" });
  const enabled = entitlements.data?.has("sermons_media") === true && canRead.data === true;
  const sermons = useSermons();
  const series = useSermonSeries();
  if (!enabled) return undefined;
  return {
    series: (series.data ?? []).map((s) => ({ id: s.id, label: s.title })),
    sermons: (sermons.data ?? [])
      .filter((s) => s.isPublished)
      .map((s) => ({ id: s.id, label: `${s.title} (${formatSermonDate(s.preachedOn)})` })),
  };
}
